import React, { useMemo } from 'react';

const PETAL_COUNT = 18;

const PetalSVG = ({ size, color }) => (
  <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 5 C25 12, 35 15, 35 22 C35 30, 28 35, 20 35 C12 35, 5 30, 5 22 C5 15, 15 12, 20 5Z"
      fill={color}
      opacity="0.85"
    />
  </svg>
);

export default function FloatingPetals() {
  const petals = useMemo(() => {
    return Array.from({ length: PETAL_COUNT }, (_, i) => ({
      id: i,
      left: `${Math.random() * 100}%`,
      bottom: `${Math.random() * 20}%`,
      size: Math.random() * 16 + 8,
      duration: `${Math.random() * 5 + 5}s`,
      delay: `${Math.random() * 8}s`,
      color: i % 3 === 0 ? '#D4526E' : i % 3 === 1 ? '#F2A7A7' : '#C9A96E',
    }));
  }, []);

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-10">
      {petals.map((p) => (
        <div
          key={p.id}
          className="petal absolute"
          style={{
            left: p.left,
            bottom: p.bottom,
            animationDuration: p.duration,
            animationDelay: p.delay,
          }}
        >
          <PetalSVG size={p.size} color={p.color} />
        </div>
      ))}
    </div>
  );
}
